import React from 'react';
import { Link } from 'react-router-dom';
import cubaimg from "../../assets/images/logo/inpro-logo-35x35.png"
import { useCountryPath } from '../../Hooks/useCountryPath';

const SidebarIcon = () => {
  const buildPath = useCountryPath();
  return (
    <div className="logo-icon-wrapper">
      <Link to={buildPath('/pages/home')}>
        <img
          className="img-fluid"
          src={cubaimg}
          alt=""
        />
      </Link>
    </div>
  );
};

export default SidebarIcon;
